/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, Prop, Mixins } from 'vue-property-decorator';
import CommonProps from '@groot-components/shared/mixins/props';

/**
 * Modal Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Title of the Component
     */
    @Prop() title!: string;

    /**
     * Subtitle of the Component
     */
    @Prop() subtitle!: string;

    /**
     * Default modal display
     */
    @Prop({ type: Boolean, default: false }) show!: boolean;

    /**
     * Remove footer
     */
    @Prop({ type: Boolean, default: false }) noFooter!: boolean;

    /**
     * Remove back button
     */
    @Prop({ type: Boolean, default: false }) noBack!: boolean;

    /**
     * Back button content
     */
    @Prop({ type: String }) backContent!: string;

    /**
     * Back button color
     */
    @Prop({ type: String, default: 'transparent' }) backColor!: string;

    /**
     * Back button click
     */
    @Prop({ type: Function, default: () => {} }) backClick!: any;

    /**
     * Remove next button
     */
    @Prop({ type: Boolean, default: false }) noNext!: boolean;

    /**
     * Next button content
     */
    @Prop({ type: String }) nextContent!: string;

    /**
     * Next button color
     */
    @Prop({ type: String, default: 'primary' }) nextColor!: string;

    /**
     * Next button click
     */
    @Prop({ type: Function, default: () => {} }) nextClick!: any;

    /**
     * Disables modal actions
     */
    @Prop({ type: Boolean, default: false }) fullscreen!: boolean;

    /**
     * Transition to show modal
     */
    @Prop({ type: String, default: 'fade' }) transition!: string;

    /**
     * Prevents closing modal
     */
    @Prop({ type: Boolean, default: false }) forced!: boolean;

    /**
     * Remove overlay background
     */
    @Prop({ type: Boolean, default: false }) noOverlay!: boolean;

    /**
     * Remove modal border
     */
    @Prop({ type: Boolean, default: false }) noBorder!: boolean;

    /**
     * Set height of modal 100%
     */
    @Prop({ type: Boolean, default: false }) fullHeight!: boolean;

    /**
     * Loading State
     */
    @Prop({ type: Boolean }) loading!: boolean;

    /**
     * Loading State using _$wait_ service
     */
    @Prop() loadingOn!: string;

    /**
     * Loading text
     */
    @Prop() loadingText!: string;

    /**
     * Loading type
     */
    @Prop({ type: String }) loadingType!: string;

    /**
     * Loading color
     */
    @Prop({ type: String }) loadingColor!: string;

    /**
     * Align footer button
     *
     * @values 'flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly'
     */
    @Prop({ type: String }) align!: string;

    /**
     * Icons library code name. here's a list of supported icons libraries:
     * 'mdi' - Material Design Icons - https://materialdesignicons.com/
     * 'fa' - Font Awesome - https://fontawesome.com/icons
     */
    @Prop({ type: String, default: 'fa' }) library!: string;

    /**
     * Prefix of the icon
     * Font Awesome prefix: 'fab', 'far', 'fas'.
     */
    @Prop({ type: String, default: 'fas' }) prefix!: string;

    /**
     * Set Button props
     */
    @Prop({ type: Object, default: () => ({}) }) button!: { [k: string]: any };
}

export default Props;
